import { deleteItemUtil, handleCloneAndCornerPosition } from "../Util/ElemUtil";
import { HistoryAction } from "./historyManager";

import $ from "jquery";

export interface PositionState {
    x: number;
    y: number;
    width: any;
    height: any;
    zoomValue: number;
}

export interface CropState extends PositionState {
    crop: any | null;
    cropCadre?: any | null;
}

//interface décrit le contrat
export interface MovementElementAction extends HistoryAction {
    type: "move_elem" | "size_elem" | "crop_elem" | "map_elem";
    item: any;
    from: { x: number; y: number, width: any, height: any, zoomValue: number };
    to: { x: number; y: number, width: any, height: any, zoomValue: number };
}

export interface MapElementAction extends HistoryAction {
    from: { x: number; y: number, width: any, height: any, zoomValue: number };
    to: { x: number; y: number, width: any, height: any, zoomValue: number };
    context: any,
}

/**
 * Applique position + taille à un item via RND et met à jour le modèle
 */
function applyPositionAndSize(item: any, state: PositionState) {
    item.rnd.current.updatePosition({ x: state.x, y: state.y });
    item.rnd.current.updateSize({ width: state.width, height: state.height });

    item.x = state.x;
    item.y = state.y;
    item.width = state.width;
    item.height = state.height;
}

export function createMoveElementAction(
    item: any,
    from: CropState,
    to: CropState
): MovementElementAction {

    return {
        type: "move_elem", item, from, to,
        undo() {

            item.rnd.current.updatePosition(from);
            item.x = from.x;
            item.y = from.y;
            if (from.crop != null) item.crop = from.crop;

            //item.rndClone.current == item is not selected
            if (item.rndClone.current != null) handleCloneAndCornerPosition(item, { x: from.x, y: from.y }, from.width, from.height, true, from.zoomValue);
        },

        redo() {
            item.rnd.current.updatePosition(to);
            item.x = to.x;
            item.y = to.y;
            if (to.crop != null) item.crop = to.crop;

            if (item.rndClone.current != null) handleCloneAndCornerPosition(item, { x: to.x, y: to.y }, to.width, to.height, true, to.zoomValue);
        }
    };
}

export function createMapElementAction(
    from: any,
    to: any,
    context: any,
): MapElementAction {
    return {
        type: "map_elem", from, to, context,
        undo() {
            if (context.setMapTaille != null) context.setMapTaille({ height: from.height, width: from.width });
            if (context.setMapPosition != null) context.setMapPosition({ x: from.x, y: from.y })

            if (context.isSelectedItem) {
                let cloneDiv = $("#clone-mapbox-id");
                cloneDiv.css({ top: from.y, left: from.x, width: from.width, height: from.height, position: 'absolute' });
            }
        },

        redo() {
            if (context.setMapTaille != null) context.setMapTaille({ height: to.height, width: to.width });
            if (context.setMapPosition != null) context.setMapPosition({ x: to.x, y: to.y });
            if (context.isSelectedItem) {
                let cloneDiv = $("#clone-mapbox-id");
                cloneDiv.css({ top: to.y, left: to.x, width: to.width, height: to.height, position: 'absolute' });
            }
        }
    };
}


export function createSizeElementAction(
    item: any,
    context: any,
    from: CropState,
    to: CropState
): MovementElementAction {
    return {
        type: "size_elem", item, from, to,
        undo() {
            applyPositionAndSize(item, from);
            item.crop = from.crop;
            item.cropCadre = from.cropCadre;

            //refresh item
            context.addItem(item)

            if (item.rndClone.current != null) handleCloneAndCornerPosition(item, { x: from.x, y: from.y }, from.width, from.height, true, from.zoomValue);
        },

        redo() {
            applyPositionAndSize(item, to);
            item.crop = to.crop;
            item.cropCadre = to.cropCadre;

            context.addItem(item)

            if (item.rndClone.current != null) handleCloneAndCornerPosition(item, { x: to.x, y: to.y }, to.width, to.height, true, to.zoomValue);
        }
    };
}

//Crop Undo Redo
export function createCropElementAction(
    item: any,
    context: any,
    from: { x: number; y: number, width: any, height: any, zoomValue: number, crop: any },
    to: { x: number; y: number, width: any, height: any, zoomValue: number, crop: any }
): MovementElementAction {

    return {
        type: "crop_elem", item, from, to,
        undo() {

            applyPositionAndSize(item, from);
            item.crop = from.crop;

            //soit on la joue magique avec le addItem, qui met à jour un item existant, et qui force le re render
            //si un jour ça fait freeze l'appli parce que trop d'item, il faudra enlever addItem, et set l'image crop en jquery css avec les valeurs de crop (rejouer l'action crop)
            context.addItem(item)

            if (item.rndClone.current != null) handleCloneAndCornerPosition(item, { x: from.x, y: from.y }, from.width, from.height, true, from.zoomValue);
        },

        redo() {

            applyPositionAndSize(item, to);
            item.crop = to.crop;

            //soit on la joue magique avec le addItem, qui met à jour un item existant, et qui force le re render
            //si un jour ça fait freeze l'appli parce que trop d'item, il faudra enlever addItem, et set l'image crop en jquery css avec les valeurs de crop (rejouer l'action crop)
            context.addItem(item)

            if (item.rndClone.current != null) handleCloneAndCornerPosition(item, { x: to.x, y: to.y }, to.width, to.height, true, to.zoomValue);
        }
    };
}

//CropCadre Undo Redo
export function createCropCadreElementAction(
    item: any,
    context: any,
    from: { x: number; y: number, width: any, height: any, zoomValue: number, cropCadre: any },
    to: { x: number; y: number, width: any, height: any, zoomValue: number, cropCadre: any }
): MovementElementAction {

    return {
        type: "crop_elem", item, from, to,
        undo() {

            /*console.log("on passe createCropCadreElementAction")
            //set rnd position
            item.rnd.current.updatePosition({ x: from.x, y: from.y });
            item.rnd.current.updateSize({ width: from.width, height: from.height });
            //set item x et y, width and height
            item.x = from.x;
            item.y = from.y;
            item.width = from.width;
            item.height = from.height;*/
            item.cropCadre = from.cropCadre;

            //soit on la joue magique avec le addItem, qui met à jour un item existant, et qui force le re render
            //si un jour ça fait freeze l'appli parce que trop d'item, il faudra enlever addItem, et set l'image crop en jquery css avec les valeurs de crop (rejouer l'action crop)
            context.addItem(item)

            if (item.rndClone.current != null) handleCloneAndCornerPosition(item, { x: from.x, y: from.y }, from.width, from.height, true, from.zoomValue);
        },

        redo() {

            /*item.rnd.current.updatePosition({ x: to.x, y: to.y });
            item.rnd.current.updateSize({ width: to.width, height: to.height });
            //set item x et y, width and height
            item.x = to.x;
            item.y = to.y;
            item.width = to.width;
            item.height = to.height;*/
            item.cropCadre = to.cropCadre;

            //soit on la joue magique avec le addItem, qui met à jour un item existant, et qui force le re render
            //si un jour ça fait freeze l'appli parce que trop d'item, il faudra enlever addItem, et set l'image crop en jquery css avec les valeurs de crop (rejouer l'action crop)
            context.addItem(item)

            if (item.rndClone.current != null) handleCloneAndCornerPosition(item, { x: to.x, y: to.y }, to.width, to.height, true, to.zoomValue);
        }
    };
}

//interface décrit le contrat
export interface addCropCadreElementAction extends HistoryAction {
    type: "add_crop_cadre_elem";
    itemCadre: any;
    itemImage: any;
    context: any;
    from: { x: number; y: number, width: any, height: any, zoomValue: number, cropCadre: any, initSrc: any, initText: any };
    to: { x: number; y: number, width: any, height: any, zoomValue: number, cropCadre: any, initSrc: any, initText: any };
}

export function createAddCropCadreElementAction(
    itemCadre: any,
    itemImage: any,
    context: any,
    from: { x: number; y: number, width: any, height: any, zoomValue: number, cropCadre: any, initSrc: any, initText: any },
    to: { x: number; y: number, width: any, height: any, zoomValue: number, cropCadre: any, initSrc: any, initText: any }
): addCropCadreElementAction {

    return {
        type: "add_crop_cadre_elem", itemCadre, itemImage, context, from, to,
        undo() {
            //marche arrière du delete et put image dans le cadre
            itemImage.x = from.x;
            itemImage.y = from.y;

            itemCadre.cropCadre = from.cropCadre;
            itemCadre.src = from.initSrc;
            itemCadre.text = from.initText;
            //en rejouer un render avec addItem, pas besoin de rnd.current.updatePosition
            context.addItem(itemImage)
            context.addItem(itemCadre)

            //item.rndClone.current == item is not selected
            //if (item.rndClone.current != null) handleCloneAndCornerPosition(item, { x: from.x, y: from.y }, from.width, from.height, true, from.zoomValue);
        },

        redo() {

            itemCadre.cropCadre = to.cropCadre;
            itemCadre.src = to.initSrc;
            itemCadre.text = to.initText;
            context.addItem(itemCadre)

            deleteItemUtil(itemImage, context);

            //if (item.rndClone.current != null) handleCloneAndCornerPosition(item, { x: to.x, y: to.y }, to.width, to.height, true, to.zoomValue);
        }
    };
}

export interface ElementAction extends HistoryAction {
    type: "delete_elem" | "add_elem";
    item: any;
}

export function createAddElementAction(
    item: any,
    context: any
): ElementAction {
    return {
        type: "add_elem", item,
        undo() { deleteItemUtil(item, context); },
        redo() { context.addItem(item) }
    };
}

export function createDeleteElementAction(
    item: any,
    context: any
): ElementAction {
    return {
        type: "delete_elem", item,
        undo() { context.addItem(item) },
        redo() { deleteItemUtil(item, context); }
    };
}

export interface OneValueElementAction extends HistoryAction {
    type: "elem-one-action";
    target: "elem-transparence" | "elem-ordre" | "map-ordre" | "letter-space" | "text-rotate" | "font-weight" | "font-style" | "text-align" | "font-size" | "font-family" | "text-decoration"
    | "map-zoom" | "map-center" | any;
    item: any;
    from: any;
    to: any;
    context: any;
}

export function createOneValueElementAction(
    params: {
        target: OneValueElementAction["target"];
        item: any;
        from: any;
        to: any;
        context: any;
    }
): OneValueElementAction {

    const { target, item, from, to, context } = params;

    function applyValue(value: any) {
        if (target === "elem-transparence") {
            //premier elem id = rnd, on prend le fils
            $("#" + item.id + " > div").css("opacity", value + '%')
            item.style['opacity'] = value;
        }
        else if (target === "elem-ordre") {
            if (context.setObjItems != null) {
                context.setObjItems(value);
            }
        }
        else if (target === "map-ordre") {
            context.setMapIndex(value);
        }
        else if (target === "letter-space") {
            $("#" + item.id + " > div").css("letter-spacing", value + 'px');
            item.style.letterSpace = value;

            if (context.getSelectedItem() != null && context.getSelectedItem().id == item.id) handleCloneAndCornerPosition(item, { x: item.x, y: item.y }, null, null, true, context.zoomValue);

        }
        else if (target === "text-rotate") {
            if (value != null) {
                $("#" + item.id + " > div").css("transform", `rotate(${value}deg)`);
                item.style.transform = `rotate(${value}deg)`;
                item.rotate = value;
            } else {
                item.style.transform = null;
            }

            if (context.getSelectedItem() != null && context.getSelectedItem().id == item.id) handleCloneAndCornerPosition(item, { x: item.x, y: item.y }, null, null, true, context.zoomValue);
        }
        else if (target === "font-weight") {
            $("#" + item.id + " > div").css("font-weight", value);
            item.style['font-weight'] = value;
        }
        else if (target === "font-style") {
            $("#" + item.id + " > div").css("font-style", value);
            item.style['font-style'] = value;
        }
        else if (target === "text-align") {
            $("#" + item.id + " > div").css("text-align", value);
            item.style['text-align'] = value;
        }
        else if (target === "font-size") {
            console.log(value)
            $("#" + item.id + " > div").css("font-size", value);
            item.style['font-size'] = value;

            if (context.getSelectedItem() != null && context.getSelectedItem() != null && context.getSelectedItem().id == item.id) handleCloneAndCornerPosition(item, { x: item.x, y: item.y }, null, null, true, context.zoomValue);
        }
        else if (target === "font-family") {
            $("#" + item.id + " > div").css("font-family", value);
            //double emploi mais fontFamily et ['font-family'] sont des attr differents
            item.style.fontFamily = value;
            item.style['font-family'] = value;

            if (context.getSelectedItem() != null && context.getSelectedItem().id == item.id) handleCloneAndCornerPosition(item, { x: item.x, y: item.y }, null, null, true, context.zoomValue);
        }
        else if (target === "text-decoration") {
            $("#" + item.id + " > div").css("text-decoration", value);
            item.style['text-decoration'] = value;
        }
        else if (target === "map-zoom") {
            var map = (window as any).$map;
            map.setZoom(value);
            if (context.setMapZoom != null) context.setMapZoom(value);
        }
        else if (target === "map-center") {
            var map = (window as any).$map;
            map.setCenter(value);
            if (context.setMapCenter != null) context.setMapCenter(value);
        }

    }

    return {
        type: "elem-one-action",
        target,
        item,
        from,
        to,
        context,

        undo() {
            applyValue(from);
        },

        redo() {
            applyValue(to);
        }
    };
}
